export class CooQueryRequest {
    body: Body = new Body();
}

export class Body {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "SAVEASDRAFT";
    DCLanguage: string = "ENU";
    DCLoginName: string = "";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class DCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DCCOOMOBILE";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCCOOMOBILE: ListOfDCCOOMOBILE = new ListOfDCCOOMOBILE();
}

export class ListOfDCCOOMOBILE {
    MEMBER: Member = new Member();
}

export class Member {
    CSN: string = "";
    ListOfSERVICEREQ: ListOfSERVICEREQ = new ListOfSERVICEREQ();
}

export class ListOfSERVICEREQ {
    SERVICEREQ: ServiceReq = new ServiceReq();
}

export class ServiceReq {
    "CSN": string = "";
    "SR Sub Type": string = "";
    "SR Type": string = "";
    "SR Number": string = ""
}


